import './_product-form-notify-me.scss';
import component from './product-form-notify-me';

export default component;
